import { render, staticRenderFns } from "./BrandModels.vue?vue&type=template&id=24991e57"
import script from "./BrandModels.vue?vue&type=script&lang=js"
export * from "./BrandModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports